import { render, staticRenderFns } from "./collectionDetail.vue?vue&type=template&id=66f4b5de&scoped=true"
import script from "./collectionDetail.vue?vue&type=script&lang=js"
export * from "./collectionDetail.vue?vue&type=script&lang=js"
import style0 from "./collectionDetail.vue?vue&type=style&index=0&id=66f4b5de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f4b5de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f4b5de')) {
      api.createRecord('66f4b5de', component.options)
    } else {
      api.reload('66f4b5de', component.options)
    }
    module.hot.accept("./collectionDetail.vue?vue&type=template&id=66f4b5de&scoped=true", function () {
      api.rerender('66f4b5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/payableCollection/cmp/collectionDetail.vue"
export default component.exports